/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Card } from './Card';
import {
    CardFromJSON,
    CardFromJSONTyped,
    CardToJSON,
} from './Card';

/**
 * 
 * @export
 * @interface AccountCardsOutput
 */
export interface AccountCardsOutput {
    /**
     * Dispalays a list of documents that have changed since original enrty date
     * @type {Array<Card>}
     * @memberof AccountCardsOutput
     */
    cards?: Array<Card>;
    /**
     * 
     * @type {Error}
     * @memberof AccountCardsOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the AccountCardsOutput interface.
 */
export function instanceOfAccountCardsOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AccountCardsOutputFromJSON(json: any): AccountCardsOutput {
    return AccountCardsOutputFromJSONTyped(json, false);
}

export function AccountCardsOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCardsOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cards': !exists(json, 'cards') ? undefined : ((json['cards'] as Array<any>).map(CardFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function AccountCardsOutputToJSON(value?: AccountCardsOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cards': value.cards === undefined ? undefined : ((value.cards as Array<any>).map(CardToJSON)),
        'error': value.error,
    };
}

